import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';
import { emailMap } from '@/constants/delta2max';
import Mailchimp from '@/components/SignUpForm/Mailchimp';
import MailchimpView from '@/components/SignUpForm/Mailchimp/BaseFormView';
import Klaviyo from '@/components/SignUpForm/Klaviyo';
import KlaviyoView from '@/components/SignUpForm/Klaviyo/BaseFormView';
import Popup from '@/components/SignUpForm/Popup';
import EFUpto from '@/components/UI/svg/delta2max/EFUpto';
import IconPlay from '@/components/UI/svg/blade/treaser/Play';
import EFVideoModal from '@/components/UI/EFVideoModal';
import { youtubeMap } from '@/constants/delta2max';

export default function J1({ stage }: any) {
    const { useLang, useRouter, useState, gtm, Link } = useGlobal();
    const { t } = useLang('delta2max.teaser');
    const { locale } = useRouter();
    const emailConf = emailMap[locale] || emailMap.us;
    const [popupVisible, setPopupVisible] = useState(false);
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);
    const SHOW_YOUTUBE: boolean = ['crowdfunding', 'detail'].includes(stage);

    const playerVideo = () => {
        setShowEFVideoModal(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: 'EcoFlow DELTA 2 Max | UX video',
            position: stage === 'crowdfunding' ? 'Product Crowdfunding_1' : 'Product_1',
            __btn_id1: css.d2xJ1,
            __btn_id2: t('sec1_watch'),
        });
    };

    return (
        <div className={`d2x-J1 ${css.d2xJ1} GtmModuleData-section`} id="d2x-J1" data-section-id={css.d2xJ1} data-section-title={t('sec1_title')}>
            <div className="sec1">
                <div className="main-box">
                    <div className="img-box">
                        <NextImage
                            webpSrc={require(`@publicLocal/delta2max/teaser/pc/${locale}/1.webp`)}
                            src={require(`@publicLocal/delta2max/teaser/pc/${locale}/1.jpg`)}
                            alt={t('sec1_title')}
                            aria-label={t('sec1_title')}
                        />
                    </div>
                    <div className="text-box">
                        <p className="title">{t('sec1_title')}</p>
                        <div className="subtitle-box">
                            <div className="subtitle-text">{t('sec1_subtitle')}</div>
                            {stage === 'teaser' && <p className="date">{t('sec1_desc')}</p>}
                            {stage !== 'teaser' && <p className="date">{t('sec1_product')}</p>}
                        </div>
                    </div>
                    {SHOW_YOUTUBE && (
                        <div className="watch-box GtmModuleData-btn-text" onClick={playerVideo}>
                            <div className="watch-text">{t('sec1_watch')}</div>
                            <div className="watch-icon">
                                <IconPlay fillBg="#fff" fillTrangle="#000" />
                            </div>
                        </div>
                    )}
                    {/* <div className="text-box">
                        <p className="title">{t('sec1_title')}</p>
                        {stage === 'teaser' && <p className="date">{t('sec1_desc')}</p>}
                        {stage === 'detail' && <p className="date">{t('sec1_product')}</p>}
                        {SHOW_YOUTUBE && (
                            <div className="watch-box" onClick={playerVideo}>
                                <div className="watch-text">{t('sec1_watch')}</div>
                                <div className="watch-icon">
                                    <IconPlay />
                                </div>
                            </div>
                        )}
                    </div> */}
                    <div className="red-dot">
                        <div className="dot-icon">
                            <NextImage
                                webpSrc={require('@publicLocal/delta2max/reddot.webp')}
                                src={require('@publicLocal/delta2max/reddot.png')}
                                alt={t('sec1_title')}
                                aria-label={t('sec1_title')}
                            />
                        </div>
                    </div>
                </div>
                {stage !== 'detail' && (
                    <div className="control-box">
                        {emailConf?.type === 'klaviyo' && (
                            <Klaviyo
                                extra_properties={{
                                    custom_source: emailConf.source,
                                    $source: emailConf.source,
                                    $method_type: 'Klaviyo Form',
                                    $consent_version: 'Embed default text',
                                    $consent_form_id: emailConf.consent_form_id,
                                }}
                                successCallback={() => {
                                    // setPopupVisible(true);
                                    try {
                                        gtm.push({
                                            event: 'uaEvent',
                                            event_name: 'activity_submit',
                                            button_name: t('sec2_sign'),
                                            status: 'success',
                                            tag: 'None',
                                        });
                                        window?.fbq && window?.fbq('track', 'Lead');
                                    } catch (e) {
                                        console.error(e);
                                    }
                                }}
                                errorCallback={() => {
                                    try {
                                        gtm.push({
                                            event: 'uaEvent',
                                            event_name: 'activity_submit',
                                            button_name: t('sec2_sign'),
                                            status: 'fail',
                                            tag: 'None',
                                        });
                                        window?.fbq && window?.fbq('track', 'Lead');
                                    } catch (e) {
                                        console.error(e);
                                    }
                                }}
                            >
                                <KlaviyoView list_id={emailConf.list_id} submitText={t('sec2_sign')} placeholder={t('sec2_placeholder')} />
                            </Klaviyo>
                        )}
                        {emailConf.type === 'mailchimp' && (
                            <>
                                <Mailchimp
                                    successCallback={() => {
                                        // setPopupVisible(true);
                                        try {
                                            gtm.push({
                                                event: 'uaEvent',
                                                event_name: 'activity_submit',
                                                button_name: t('sec2_sign'),
                                                status: 'success',
                                                tag: 'None',
                                            });
                                            window?.fbq('track', 'Lead');
                                        } catch (e) {
                                            console.error(e);
                                        }
                                    }}
                                    errorCallback={() => {
                                        try {
                                            gtm.push({
                                                event: 'uaEvent',
                                                event_name: 'activity_submit',
                                                button_name: t('sec2_sign'),
                                                status: 'fail',
                                                tag: 'None',
                                            });
                                            window?.fbq('track', 'Lead');
                                        } catch (e) {
                                            console.error(e);
                                        }
                                    }}
                                >
                                    <MailchimpView
                                        action={emailConf.action}
                                        extraFields={emailConf.extraFields}
                                        submitText={t('sec2_sign')}
                                        placeholder={t('sec2_placeholder')}
                                    />
                                </Mailchimp>
                            </>
                        )}
                        <div className="save-icon">
                            <EFUpto text={t('sec2_up_to')} />
                        </div>
                    </div>
                )}
                {locale === 'jp' && stage !== 'detail' && (
                    <div className="line-box">
                        <div
                            className="line-img-box"
                            onClick={() => {
                                try {
                                    window?.fbq('track', 'Lead');
                                } catch (e) {
                                    console.error(e);
                                }
                            }}
                        >
                            <Link
                                href="https://lin.ee/g7W0VbD"
                                dataLayer={{ event: 'uaEvent', event_name: 'line_icon_click', button_name: 'Line', url: 'https://lin.ee/g7W0VbD' }}
                            >
                                <NextImage
                                    webpSrc={require('@publicLocal/delta2max/teaser/pc/jp/line.webp')}
                                    src={require('@publicLocal/delta2max/teaser/pc/jp/line.png')}
                                />
                            </Link>
                        </div>
                        <div className="line-img-box code">
                            <NextImage
                                webpSrc={require('@publicLocal/delta2max/teaser/pc/jp/qrcode.webp')}
                                src={require('@publicLocal/delta2max/teaser/pc/jp/qrcode.png')}
                            />
                        </div>
                        <div className="line-text">
                            {t.rich('sec2_desc', {
                                link: (text: string) => (
                                    <div className="link-div" onClick={() => window?.fbq && window?.fbq('track', 'Lead')}>
                                        <Link
                                            className="link"
                                            href={'https://lin.ee/MaT2hbS'}
                                            dataLayer={{ event: 'uaEvent', event_name: 'offical_line_join', button_name: text, url: 'https://lin.ee/MaT2hbS' }}
                                        >
                                            {text}
                                        </Link>
                                    </div>
                                ),
                            })}
                        </div>
                    </div>
                )}
            </div>
            <Popup
                visible={popupVisible}
                title={t('sec2_popup_title')}
                content={t('sec2_popup_desc')}
                buttonText={t('sec2_popup_btn')}
                onCancel={() => setPopupVisible(false)}
                btnLink={emailConf.popupBtnLink}
            />
            <EFVideoModal
                visible={showEFVideoModal}
                source={youtubeMap[locale] || youtubeMap.us}
                onClose={() => setShowEFVideoModal(false)}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            />
        </div>
    );
}
